
// => Styling
import styles from './BoosterPackOpening.module.css';

// => Data
import { boosterPacks } from '../../../content/boosterPacks';

// => Components
import CardInspect from './CardInspect';

// => 3rd party
import ConfettiExplosion from 'react-confetti-explosion';

// => React
import { useEffect, useRef, useState } from 'react';


// ============
// Component
// ============
const BoosterPackOpening = ({
    boosterPackId = boosterPacks[0].id,
    cardsAmount = 3,
    unlockedCards = [],
    requestUnlockCards = (cs) => {},
    onAbort = () => {},
}) => {

    
    const findBoosterPack = () => {
        return boosterPacks.find(bp => bp.id === boosterPackId)
    }
    
    const generateCards = () => {

        let bp = findBoosterPack()
        let pool = bp.pool.filter(c => {
            return unlockedCards.includes(c.id) === false
        })
        if (pool.length === 0) {
            // TODO: no possible pool!!! abort!
            onAbort()
            return null
        }

        let result = []
        for (let i = 0; i < cardsAmount; i++) {
            let card = getRandomCardFromPool(pool)
            if (card) {
                pool = pool.filter(pc => pc.id !== card.id)
                result.push(card)
            }
        }

        // request to add cards to inventory
        requestUnlockCards(result)

        return result
    }

    const getRandomCardFromPool = (pool = []) => {
        let rndIndex = Math.floor(Math.random() * (pool.length - 0) + 0)
        return pool[rndIndex]
    }

    const [cardsResult, setCardsResult] = useState(null)

    /*useEffect(() => {
        if (cardsResult === null) {
            setCardsResult(generateCards())
        }
    })*/
   const cardsGenerated = useRef(false)
   useEffect(() => {
        if (cardsGenerated.current === false) {
            setCardsResult(generateCards())
            cardsGenerated.current = true
        }
   }, [cardsGenerated])

    const getCardIndex = (id) => {
        let set = findBoosterPack()
        return set.pool.findIndex(e => e.id === id)
    }

    const [confetti, setConfetti] = useState(true)

    const getCardsAmount = () => {
        if (cardsResult) return cardsResult.length
        else return cardsAmount
    }

    const isSetComplete = () => {
        let bp = findBoosterPack()
        let pool = bp.pool.filter(c => {
            return unlockedCards.includes(c.id) === false
        })
        if (pool) return pool.length === 0
        else return false
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container}>

            <div className={styles.header}>
                <span className={styles.title}>You have unlocked <span style={{color: '#ff317c', textDecoration: 'underline', fontSize: '24pt'}}>{getCardsAmount()}</span> new cards!</span>
                <span className={styles.subtitle}>Make sure to enable relevant content tags in your settings to see them ingame.</span>
                {(cardsGenerated.current && isSetComplete()) && 
                    <span style={{color: '#ff317c', fontSize: '14pt', fontWeight: 'bold'}}>Congratulations! You have completed the whole set!</span>
                }
            </div>
            
            <div className={styles.cards}>
            {cardsResult && cardsResult.map(c =>
                <CardInspect key={"Key_"+c.id+"_bpopening"}
                data={c}
                index={getCardIndex(c.id)}
                set={boosterPackId}
                defaultScale={0.8}
                showTags={false} />
            )}
            </div>

            {confetti && <ConfettiExplosion colors={['#ff5090', '#cd1256', '#ebebeb', '#d5d5d5', '#ff5090']} zIndex={100} force={0.8} duration={2000} particleCount={250} width={1600} onComplete={()=>setConfetti(false)} />}
        </div>
    );
}


export default BoosterPackOpening